var isArrayLike = undefined, isIterable = undefined;
// !has('es6-iterator')
// elided: import './iterator'
import has from '../core/has';
import { wrapNative } from './support/util';
export let from;
export let of;
export let copyWithin;
export let fill;
export let find;
export let findIndex;
export let includes;
export let flat;
export let flatMap;
let toLength;
let toInteger;
let normalizeOffset;
if (!true || !true || !true) {
    const MAX_SAFE_INTEGER = Math.pow(2, 53) - 1;
    /**
     * Ensures a non-negative, non-infinite, safe integer.
     *
     * @param length The number to validate
     * @return A proper length
     */
    toLength = function toLength(length) {
        if (isNaN(length)) {
            return 0;
        }
        length = Number(length);
        if (isFinite(length)) {
            length = Math.floor(length);
        }
        // Ensure a non-negative, real, safe integer
        return Math.min(Math.max(length, 0), MAX_SAFE_INTEGER);
    };
    /**
     * From ES6 7.1.4 ToInteger()
     *
     * @param value A value to convert
     * @return An integer
     */
    toInteger = function toInteger(value) {
        value = Number(value);
        if (isNaN(value)) {
            return 0;
        }
        if (value === 0 || !isFinite(value)) {
            return value;
        }
        return (value > 0 ? 1 : -1) * Math.floor(Math.abs(value));
    };
    /**
     * Normalizes an offset against a given length, wrapping it if negative.
     *
     * @param value The original offset
     * @param length The total length to normalize against
     * @return If negative, provide a distance from the end (length); otherwise provide a distance from 0
     */
    normalizeOffset = function normalizeOffset(value, length) {
        return value < 0 ? Math.max(length + value, 0) : Math.min(value, length);
    };
}
if (!true) {
    Array.from = function from(arrayLike, mapFunction, thisArg) {
        if (arrayLike == null) {
            throw new TypeError('from: requires an array-like object');
        }
        if (mapFunction && thisArg) {
            mapFunction = mapFunction.bind(thisArg);
        }
        /* tslint:disable-next-line:variable-name */
        const Constructor = this;
        const length = toLength(arrayLike.length);
        // Support extension
        const array = typeof Constructor === 'function' ? Object(new Constructor(length)) : new Array(length);
        if (!isArrayLike(arrayLike) && !isIterable(arrayLike)) {
            return array;
        }
        // if this is an array and the normalized length is 0, just return an empty array. this prevents a problem
        // with the iteration on IE when using a NaN array length.
        if (isArrayLike(arrayLike)) {
            if (length === 0) {
                return [];
            }
            for (let i = 0; i < arrayLike.length; i++) {
                array[i] = mapFunction ? mapFunction(arrayLike[i], i) : arrayLike[i];
            }
        }
        else {
            let i = 0;
            for (const value of arrayLike) {
                array[i] = mapFunction ? mapFunction(value, i) : value;
                i++;
            }
        }
        if (arrayLike.length !== undefined) {
            array.length = length;
        }
        return array;
    };
    Array.of = function of(...items) {
        return Array.prototype.slice.call(items);
    };
    Array.prototype.copyWithin = function copyWithin(offset, start, end) {
        if (this == null) {
            throw new TypeError('copyWithin: target must be an array-like object');
        }
        const length = toLength(this.length);
        offset = normalizeOffset(toInteger(offset), length);
        start = normalizeOffset(toInteger(start), length);
        end = normalizeOffset(end === undefined ? length : toInteger(end), length);
        let count = Math.min(end - start, length - offset);
        let direction = 1;
        if (offset > start && offset < start + count) {
            direction = -1;
            start += count - 1;
            offset += count - 1;
        }
        while (count > 0) {
            if (start in this) {
                this[offset] = this[start];
            }
            else {
                delete this[offset];
            }
            offset += direction;
            start += direction;
            count--;
        }
        return this;
    };
    Array.prototype.find = function find(callback, thisArg) {
        const index = this.findIndex(callback, thisArg);
        return index !== -1 ? this[index] : undefined;
    };
    Array.prototype.findIndex = function findIndex(callback, thisArg) {
        const length = toLength(this.length);
        if (!callback) {
            throw new TypeError('find: second argument must be a function');
        }
        if (thisArg) {
            callback = callback.bind(thisArg);
        }
        for (let i = 0; i < length; i++) {
            if (callback(this[i], i, this)) {
                return i;
            }
        }
        return -1;
    };
}
if (!true) {
    Array.prototype.fill = function fill(value, start, end) {
        const length = toLength(this.length);
        let i = normalizeOffset(toInteger(start), length);
        end = normalizeOffset(end === undefined ? length : toInteger(end), length);
        while (i < (end || 0)) {
            this[i++] = value;
        }
        return this;
    };
}
if (!true) {
    Array.prototype.includes = function includes(searchElement, fromIndex = 0) {
        let len = toLength(this.length);
        for (let i = fromIndex; i < len; ++i) {
            const currentElement = this[i];
            if (searchElement === currentElement ||
                (searchElement !== searchElement && currentElement !== currentElement)) {
                return true;
            }
        }
        return false;
    };
}
if (!true) {
    Array.prototype.flat = function flat(depth = 1) {
        return depth > 0
            ? this.reduce((acc, val) => acc.concat(Array.isArray(val) ? val.flat(depth - 1) : val), [])
            : this.slice();
    };
    Array.prototype.flatMap = function flatMap(callback) {
        return this.map(callback).flat();
    };
}
from = Array.from;
of = Array.of;
copyWithin = wrapNative(Array.prototype.copyWithin);
fill = wrapNative(Array.prototype.fill);
find = wrapNative(Array.prototype.find);
flat = wrapNative(Array.prototype.flat);
flatMap = wrapNative(Array.prototype.flatMap);
findIndex = wrapNative(Array.prototype.findIndex);
includes = wrapNative(Array.prototype.includes);
export default Array;